import React, { useRef } from 'react';
import { TweenLite } from 'gsap';

export interface ILegalDescriptionProps {
    style: React.CSSProperties;
    index: number;
    legalDescription: string;
}

const TractLegalDescription: React.FC<ILegalDescriptionProps> = (props) => {
    const legalDescriptionElement = useRef([]);  

    const toggleLegalDesc = (state: boolean, clientX: number, clientY: number) => {
        if (state) {
            TweenLite.set(
                legalDescriptionElement.current[props?.index],
                { top: `${clientY}`, left: `${clientX}`, width: '500px', height: 'auto', position: 'fixed', display: 'inline-block', background: 'white', borderColor: '#6393C1', zIndex: 100 }
            );
        } else {
            TweenLite.to(legalDescriptionElement.current[props?.index], 0.2, { height: '2.5rem', display: 'none', background: 'transparent', borderColor: 'transparent', zIndex: 0 });
        }
    };

    return (
        <>
            <span
                onMouseOver={(e) => toggleLegalDesc(true, e.clientX, e.clientY)}
                onMouseOut={() => toggleLegalDesc(false, 0, 0)}
                style={{ paddingRight: '20px', overflow: 'hidden', display: 'flex', whiteSpace: 'nowrap' }}
            >
                <div style={{fontSize: '15px', paddingRight: '20px'}}>👁‍🗨</div>
            </span>
            <span
                dir="ltr"
                ref={el => legalDescriptionElement.current[props?.index] = el}
                style={{
                    borderRadius: '5px',
                    display: 'none',
                    overflow: 'hidden',
                    position: 'absolute',
                    border: '2px solid transparent',
                    padding: '.3rem',
                    background: 'transparent',
                    borderColor: 'transparent',
                    zIndex: 100,
                    height: 'auto',
                }}
            >
            {props?.legalDescription}
            </span>
            <div className="owner-tract-legal-description" id={`legalDescriptionDiv${props?.index}`} style={{ fontSize: '12px', marginRight: '1rem' }}> {props?.legalDescription}</div>
        </>
    );
};

export default TractLegalDescription;



// WEBPACK FOOTER //
// ./src/components/common/TractLegalDescription.tsx